import React, { Component } from 'react'; 
import { Table, Pagination, FormControl, InputGroup, Dropdown, DropdownButton} from 'react-bootstrap';
import _ from 'lodash';
// import Template from './Template'
import ModalWindow from './ModalWindow'

function searchingFor(term, eventKey, subKey){ 
	return function(x){    
    if(_.isArray(x[eventKey])){
      let a = x[eventKey];
      let gg =[]
      _.map(a, (obj) =>{
        gg.push(_.includes(obj[subKey].toLowerCase(), term.toLowerCase()))
      })
      return _.includes(gg, true) || !term
    } else {
      return _.includes(x[eventKey].toLowerCase(), term.toLowerCase()) || !term;
    }
	}
}

 export default class MappedForm extends Component {
  constructor(props){
		super(props)
		this.state={
      activePage: 1,
      term:'',
      eventKey:"auditType",
      subKey:""
		}
  }
  componentDidMount(){    
    this.props.function.TokenValidation()  
    this.props.function.MappedListaction()    
    this.props.function.templateNames() 
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }	
  readMe = (prop,index) =>{
    this.setState({[prop+index]:true})
  }
  readMeClose = (prop,index) =>{
    this.setState({[prop+index]:false})
  }
  handleChange = (e) => {
		this.setState({term:e.target.value})	
  }
  searchFilter =(e, sub) =>{
    this.setState({eventKey:e, subKey:sub})
    if(!_.isEqual(this.state.eventKey, e)){
      this.setState({term:''})
    }
  }  
   render(){
    const{mappedData, accessPermission} = this.props;
    const{activePage, term, eventKey, subKey} = this.state;
    let permission  = _.includes(accessPermission, 'WRITE') 
    const Per_Page=50;
		let totalPages = 1
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
		let items = [];
    if(!_.isEmpty(mappedData)){
      let totalPages = Math.ceil(mappedData.length/Per_Page)
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
    }
    }
     return(<div>
       <span className='alignRight'>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
            <DropdownButton
            as={InputGroup.Append}
            alignRight
						variant="outline-secondary"
            title=""           
            id="dropdown-menu-align-right"
						> 
             <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, '')}  eventKey="auditType" active={eventKey === "auditType"}  ><b>AUDIT TYPE</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, '')} eventKey="templateName" active={eventKey === "templateName"}  ><b>TEMPLATE NAME</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'processName')} eventKey="process" active={eventKey === "process"}  ><b>PROCESS</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'clientName')} eventKey="client" active={eventKey === "client"}  ><b>CLIENT</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'centerName')} eventKey="center" active={eventKey === "center"}  ><b>CENTER</b></Dropdown.Item> 
             </DropdownButton>
				</InputGroup>
			 </span>
       <Table responsive>
         <thead>
         <th>REGION</th>
          <th>CENTER</th>
          <th>CLIENT</th>
          <th>PROCESS</th>
          <th>AUDIT TYPE</th>
          <th>EVALUATION TEMPLATE NAMES</th>   
           <th>ACTIONS</th>
         </thead>
         <tbody>
           {!_.isEmpty(mappedData) ? 
           _.map(mappedData.filter(searchingFor(term, eventKey, subKey)), (obj, index)=>{
             	if(index >= startOffset & startCount < Per_Page){
								startCount++;
             return(
             <tr>
               <td>{obj.region.regionName}</td>
               <td style={{width:'200px', wordBreak:'break-word'}}>{_.map(obj.center, (item,index) => {return item.centerName}).join(",") }</td>
               <td style={{width:'200px', wordBreak:'break-word'}}>{_.map(obj.client, (item,index) => {return item.clientName}).join(",") }</td>
               <td style={{width:'200px', wordBreak:'break-word'}}>{_.map(obj.process, (item,index) => {return item.processName}).join(",")}</td>
               <td>{obj.auditType }</td>
               <td>{obj.templateName}</td>
               <td className='readMe'>   
               <i class='fas fa-eye' onClick={()=>this.readMe('readAudit',index)}/>
                {this.state['readAudit'+index] ?
                  <ModalWindow auditorJson={obj}  dataList={this.props.payload} closeModal={()=>this.readMeClose('readAudit',index)}/> : null
                }
              {(permission === true) ?
              <span>
                {/* <i class='fas fa-pen' onClick={()=>this.readMe('readme',index)}/>
                  {this.state['readme'+index] ? <Template closeModal={()=>this.readMeClose('readme',index)} 
                    function={this.props.function} edit={true} nameList={this.props.nameList}
                    dataList={this.props.payload} templatepayload={obj}/>                  
                  : null} */}
                <i class="fas fa-link" onClick={()=>this.readMe('link', index)} />
               {this.state['link'+index] ? 
                <ModalWindow link={true} closeModal={()=>this.readMeClose('link', index)}
                function={this.props.function} nameList={this.props.nameList} data={obj}/>             
                : null}
             </span>
              : null}
              </td>
             </tr>)
            }
           }) :
           <tr><td colSpan={(permission === true) ? "7" : "6"}>No Records Found</td></tr>
           }
         </tbody>
         </Table>
         {!_.isEmpty(items) ?
         <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination> : null}
       </div>)

  }
}